
import React from "react";
import { TableBody, TableCell, TableRow } from "@/components/ui/table";

interface ChippingTableBodyProps {
  testPoints: string[];
  scores: Record<string, (number | null)[]>;
  getFormattedPoint: (point: string) => string;
  getPointTotal: (point: string) => number;
  getGrandTotal: () => number;
  getTestDistances?: (testId: string) => Record<string, string>;
  selectedTest?: string | null;
}

const ChippingTableBody: React.FC<ChippingTableBodyProps> = ({
  testPoints,
  scores,
  getFormattedPoint,
  getPointTotal,
  getGrandTotal,
  getTestDistances,
  selectedTest
}) => {
  const distances = selectedTest && getTestDistances ? getTestDistances(selectedTest) : {};
  
  console.log("ChippingTableBody - testPoints:", testPoints);
  console.log("ChippingTableBody - scores:", JSON.stringify(scores));
  console.log("ChippingTableBody - distances:", distances);
  
  return (
    <TableBody>
      {testPoints.map((point) => {
        const pointScores = scores[point] || Array(10).fill(null);
        console.log(`ChippingTableBody - point ${point} scores:`, pointScores);
        
        return (
          <TableRow key={point}>
            <TableCell className="font-medium">
              {point}
            </TableCell>
            <TableCell className="font-medium text-green-600">
              {distances[point] || ""}
            </TableCell>
            {Array.from({ length: 10 }, (_, index) => (
              <TableCell key={index} className="text-center">
                {pointScores[index] !== null && pointScores[index] !== undefined
                  ? pointScores[index]
                  : "-"}
              </TableCell>
            ))}
            <TableCell className="text-center font-bold">
              {getPointTotal(point)}
            </TableCell>
          </TableRow>
        );
      })}
      <TableRow>
        <TableCell colSpan={2} className="text-right font-bold">
          Total Points
        </TableCell>
        <TableCell colSpan={10} />
        <TableCell className="text-center font-bold">{getGrandTotal()}</TableCell>
      </TableRow>
    </TableBody>
  );
};

export default ChippingTableBody;
